import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';
import { preface } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    // height: '100%',
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  }
}));

const Preface = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="section"
        container
      >
        <Grid
          component="article"
          container
        >
          <Grid
            alignItems="center"
            container
            md={6}
            sm={12}
            xs={12}
          >
            <Paper
              align="right"
              className={classes.paper}
            >
              <Typography
                component="h2"
                variant="h2"
              >
                Plantez de vrais arbres
              </Typography>
              <Typography
                component="p"
                variant="body2"
              >
                Apprenez à développer vos forêts en prenant en compte l’impact éco-systémique des arbres que vous plantez ou en fonction des ressources que vous voulez produire.
              </Typography>
              <Typography
                component="p"
                variant="body2"
              >
                A travers des mécaniques de jeu inspirées de l'acte de planter et d'entretenir des arbres, nous vous donnons la possibilité de financer de vrais projets de reforestations.
              </Typography>
            </Paper>
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
          >
            <Paper className={classes.paper}>
              <CardMedia
                alt={preface[0].alt}
                component="img"
                image={preface[0].img}
                object-fit
                title={preface[0].title}
              />
            </Paper>
          </Grid>

        </Grid>
        <Grid
          component="article"
          container
        >
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
          >
            <Paper className={classes.paper}>
              <CardMedia
                alt={preface[1].alt}
                component="img"
                object-fit
                src={preface[1].img}
                title={preface[1].title}
              />
            </Paper>
          </Grid>
          <Grid
            alignItems="center"
            container
            md={6}
            sm={12}
            xs={12}
          >
            <Paper
              className={classes.paper}
            >
              <Typography
                component="h2"
                variant="h2"
              >
                Vos victoires sont réelles
              </Typography>
              <Typography
                component="p"
                variant="body2"
              >
                Participez à des objectifs de reforestation à grande échelle en rejoignant une communauté de joueurs prête à progresser et partager avec vous une aventure inédite et une expérience innovante.
              </Typography>
              <Typography
                component="p"
                variant="body2"
              >
                Grâce aux revenus publicitaires et/ou à l'achat dans le magasin du jeu, vous soutenez nos associations partenaires engagées dans des projets de reforestations cohérents et respectueux.
              </Typography>
            </Paper>
          </Grid>

        </Grid>
      </Grid>
    </>
  );
}

export default Preface;
